/** @jsx jsx */
import { useContext } from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';

import { ChallengeSection, ProductsList } from 'components';
import { CHALLENGE_PHASE } from 'constants/challenges';
import { formatApiURI } from 'services/api';
import { getResultUnit } from 'utils';
import { ChallengeListDetailsContext } from '..';

export default function ProductsAndGainsSection() {
  const { t } = useTranslation();
  const { challenge, challengeResult, productCurrency, currentPhase } =
    useContext(ChallengeListDetailsContext);
  const exportUrl = formatApiURI(
    `export/challenge-list-products/${challenge.id}`,
  );
  const isDisabled = currentPhase === CHALLENGE_PHASE.AFTER_CHALLENGE;

  return (
    <ChallengeSection
      defaultExpanded={!challengeResult}
      title={<strong>{t('challenges.detail.productsAndGain.title')}</strong>}
      isDisabled={isDisabled}
    >
      <ProductsList
        exportUrl={exportUrl}
        products={challenge.challengeListProducts ?? []}
        getProductTitle={(product) => {
          if (challenge.isRewardingGlobal) {
            const resultUnit = getResultUnit(challenge);
            return `${product.coefficient} ${resultUnit}`;
          }
          const thresholdMessage =
            product.threshold! > 1
              ? `${t('challenges.declaration.thresholdUnit')} ${t(
                  'challenges.declaration.thresholdTitle',
                  {
                    threshold: product.threshold,
                  },
                )}`
              : '';
          return `${product.reward} ${productCurrency} ${thresholdMessage}`;
        }}
        rowsPerPage={16}
        isDisabled={isDisabled}
      />
    </ChallengeSection>
  );
}
